// Shared look for the super-admin panels (ticket 38 AccountsOverview, ticket 167 SpendApprovals).
import React from 'react';
import { Loader2 } from 'lucide-react';

export function Panel({ title, sub, icon: Icon, testid, children, action }) {
  return (
    <section className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden" data-testid={testid}>
      <div className="flex items-start gap-3 px-5 py-4 border-b border-slate-100">
        {Icon && <div className="p-2 rounded-lg mt-0.5" style={{ background: '#070B5F15', color: '#070B5F' }}><Icon size={16} /></div>}
        <div className="flex-1 min-w-0">
          <h2 className="font-serif text-lg font-bold leading-tight" style={{ color: '#070B5F' }}>{title}</h2>
          {sub && <p className="text-[12px] text-slate-500 mt-0.5">{sub}</p>}
        </div>
        {action}
      </div>
      {children}
    </section>
  );
}

export const Loading = ({ testid, label }) => (
  <div className="text-slate-500 flex items-center gap-2 text-sm" data-testid={testid}>
    <Loader2 size={16} className="animate-spin" /> {label}
  </div>
);

export const ErrorBox = ({ testid, error }) => (
  <div className="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800" data-testid={testid}>
    {String(error)}
  </div>
);
